<template>
  <div>
    <div
      v-for="(item, gameIndex) in all_game_list"
      :id="'game' + gameIndex"
      :key="gameIndex"
      class="new-list"
    >
      <div
        v-if="item.direction != 2"
        :id="item.name"
        class="game_title"
      >
        <div
          class="game_title_left"
          :class="item.case_tpl_id"
        >
          <img
            :id="item.name"
            :src="item.thumb"
            alt=""
          ><span v-if="item.pid == 0">{{ item.abbr }}</span>
        </div>
        <!-- 分页导航 -->
        <div class="game_title_right">
          <div class="left">
            <van-icon
              name="arrow-left"
              @click="prevPage(gameIndex)"
            />
          </div>
          <div class="center">
            {{ $t("全部") }} {{ item.children_games.length }}
          </div>
          <div
            class="right"
            @click="nextPage(gameIndex)"
          >
            <van-icon name="arrow" />
          </div>
          <div
            class="all"
            @click="$router.push({ path: 'recente', query: { gameId: 'Popular', flag: true } })"
          >
            {{ $t("更多的") }}
          </div>
        </div>
      </div>
      <div
        v-else
        :id="item.name"
        class="slots_title"
      >
        {{ $t("所有游戏") }}
      </div>
      <div
        v-if="item.direction == 2"
        class="fake"
      >
        <div class="container">
          <div
            v-for="i in 4"
            :id="i % 2 ? 'left' : 'right'"
            :key="i"
            :class="i % 2 ? 'left' : 'right'"
          >
            <div
              :id="i % 2 ? 'leftWrap' : 'rightWrap'"
              :ref="i % 2 ? 'leftWrap' : 'rightWrap'"
              @click.stop="handleGameClick"
            >
              <div 
                class="item-img"
              >
                <img
                  v-for="citem in getSafeGames(item, i-1)"
                  :key="citem.id"
                  :src="citem.image"
                  alt=""
                  class="game-image"
                  :data-game-id="citem.id"
                  :data-game-index="i-1"
                  :data-game-name="citem.game_name"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="item.direction == 2"
        class="slots-video"
      >
        <img
          style="width: 100%;"
          src="https://cdn.bz999xyz.xyz/image/2024/09/10/46ebb50813fb43c5bb10e3a690ffb32f.avif"
          alt=""
        >
        <div class="video-info">
          GRUPO HMS
        </div>
      </div>
      <div
        v-if="item.direction != 2"
        class="carousel-viewport"
        :style="item.children_games.length < 4 ? 'height:100%' : ''"
      >
        <transition
          :name="pageInfo[gameIndex].transitionName"
          mode="out-in"
        >
          <div
            :key="pageInfo[gameIndex].currentPage"
            class="carousel-wrapper"
          >
            <div
              class="carousel-list"
              :class="item.case_tpl_id"
            >
              <div
                v-for="(citem, index) in getPaginatedGames(item.children_games, gameIndex)"
                :key="index"
                class="game-item"
                :class="item.case_tpl_id"
                @click="$parent.playGame(citem, item)"
              >
                <div
                  v-lazy:background-image="citem.image"
                  class="innerbox"
                >
                  <div class="link_user">
                    <van-icon name="user" />{{ citem.game_num }}
                  </div>
                  <img
                    v-if="citem.is_collect == 1"
                    class="like_icon"
                    src="../assets/images/category/like_color.png"
                    alt=""
                    @click.stop="setFavoritos(citem)"
                  >
                  <img
                    v-else
                    class="like_icon"
                    src="../assets/images/category/like.png"
                    alt=""
                    @click.stop="setFavoritos(citem)"
                  >
                  <img
                    v-if="!citem.is_works && item.is_game_list == 1"
                    src="../assets/images/common/nowork.png"
                    class="nowork"
                  >
                </div>
                <div class="game_item_pg_name">
                  {{ citem.game_name }}
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Fetch from "../utils/fetch"
export default {
    name: "IndexListHermes",
    props: {
        all_game_list: Array
    },
    data() {
        return {
            gamesPerPage: 8, // 每页显示的游戏数量
            currentPage: 0, // 当前页码
            pageInfo: {},// 存储每个模块的分页信息
            clickDebounce: false // 防抖标志

        };
    },
    computed: {
        colletIds() {
            return this.$parent.colletList.map(({ id }) => id)
        },
        popularList() {
            if (!this.all_game_list[0].children_games) return 0;
            const start = this.currentPage * this.gamesPerPage;
            const end = start + this.gamesPerPage;
            return this.all_game_list[0].children_games.slice(start, end);
        },
        // 计算总页数
        totalPages() {
            if (!this.all_game_list[0].children_games) return 0;
            return Math.ceil(this.all_game_list[0].children_games.length / this.gamesPerPage);
        },
    },
    watch: {
        all_game_list: {
            deep: true, //深度监听设置为 true
            handler: function (newV) {
                this.all_game_list = newV;
                newV.forEach((item, index) => {
                    if (!this.pageInfo[index]) {
                        this.$set(this.pageInfo, index, {
                            currentPage: 0,
                            gamesPerPage: 8,
                            transitionName: 'slide-left'
                        });
                    }
                });
            },
            immediate: true
        }
    },
    mounted() {
        if (this.all_game_list && this.all_game_list.length > 0 && 
            (this.all_game_list[0].case_tpl_id == 'case_1' || this.all_game_list[0].case_tpl_id == 'case_5')) {
            this.$nextTick(() => {
                this.autoPlayLeft();
                this.autoPlayRight();
                this.autoPlayLeft1();
                this.autoPlayRight1();
            })
        }

    },
    beforeDestroy() {
        // 清理定时器
        if (this.timerLeft) {
            clearInterval(this.timerLeft);
        }
        if (this.timerRight) {
            clearInterval(this.timerRight);
        }
        if (this.timerLeft1) {
            clearInterval(this.timerLeft1);
        }
        if (this.timerRight1) {
            clearInterval(this.timerRight1);
        }
    },
    methods: {
        // 获取安全的游戏数据
        getSafeGames(item, index) {
            if (!item || !item.children_games) {
                return [];
            }
            
            if (!item.children_games[index] || !Array.isArray(item.children_games[index])) {
                return [];
            }
            
            return item.children_games[index];
        },
        // 获取当前页的游戏列表
        getPaginatedGames(games, moduleIndex) {
            if (!games || !this.pageInfo[moduleIndex]) return [];

            const start = this.pageInfo[moduleIndex].currentPage * this.pageInfo[moduleIndex].gamesPerPage;
            const end = start + this.pageInfo[moduleIndex].gamesPerPage;

            return games.slice(start, end);
        },
        // 上一页
        prevPage(moduleIndex) {
            if (this.pageInfo[moduleIndex].currentPage > 0) {
                this.pageInfo[moduleIndex].transitionName = 'slide-right';
                this.pageInfo[moduleIndex].currentPage--;
            }
        },
        // 下一页
        nextPage(moduleIndex) {
            const totalPages = Math.ceil(this.all_game_list[moduleIndex].children_games.length /
                this.pageInfo[moduleIndex].gamesPerPage);

            if (this.pageInfo[moduleIndex].currentPage < totalPages - 1) {
                this.pageInfo[moduleIndex].transitionName = 'slide-left';
                this.pageInfo[moduleIndex].currentPage++;
            }
        },
        showMore(item) {
            item.step_show += 12
            this.$forceUpdate()
        },
        handleGameClick(event) {
            // 防抖处理，避免快速重复点击
            if (this.clickDebounce) {
                console.log('点击过快，忽略');
                return;
            }
            
            // 获取点击的目标元素
            const target = event.target;
            
            // 检查是否点击的是img元素且有游戏数据
            if (target.tagName !== 'IMG' || !target.dataset.gameId) {
                console.log('点击的不是游戏图片');
                return;
            }
            
            this.clickDebounce = true;
            setTimeout(() => {
                this.clickDebounce = false;
            }, 1000);
            
            // 从target获取游戏数据
            const gameId = target.dataset.gameId;
            const gameIndex = parseInt(target.dataset.gameIndex);
            const gameName = target.dataset.gameName;
            
            console.log('=== 事件委托游戏点击 ===');
            console.log('从target获取的数据：', { gameId, gameIndex, gameName });
            
            this.handleDynamicClick(gameIndex, gameId);
        },
        
        handleDynamicClick(index, id) {
            console.log('=== 执行游戏启动逻辑 ===');
            console.log('点击游戏，参数：', { index, id });
            
            // 找到 direction == 2 的游戏类别
            const gameCategory = this.all_game_list.find(category => category.direction == 2);
            
            if (!gameCategory) {
                console.error('找不到 direction == 2 的游戏类别');
                this.clickDebounce = false; // 重置防抖
                return;
            }
            
            // 使用安全方法获取游戏数组
            const games = this.getSafeGames(gameCategory, index);
            
            if (games.length === 0) {
                console.error('没有找到游戏数据');
                this.clickDebounce = false; // 重置防抖
                return;
            }
            
            // 查找指定的游戏
            const selectedGame = games.find(game => game.id == id);
            
            if (!selectedGame) {
                console.error('找不到对应的游戏：', { id, games });
                this.clickDebounce = false; // 重置防抖
                return;
            }
            
            console.log('找到的游戏：', selectedGame);
            
            // 调用父组件的 playGame 方法
            if (this.$parent && this.$parent.playGame) {
                this.$parent.playGame(selectedGame, gameCategory);
                console.log('游戏启动成功');
            } else {
                console.error('父组件的 playGame 方法不存在');
                this.clickDebounce = false; // 重置防抖
            }
        },
        autoPlayLeft() { //向上轮播 
            var speedup = 1; //初始化速度
            var leftWrap = this.$refs.leftWrap && this.$refs.leftWrap[0]; //如果这里使用上面的方法不行的华，就使用refs来获取也行
            if (!leftWrap) return; //如果元素不存在，直接返回
            leftWrap.innerHTML += leftWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            leftWrap.style.height = oImgs.length * 200 + "px"; //680 是一张图片高度

            this.timerLeft = setInterval(function () {
                if (leftWrap.offsetTop < -400) { //向上轮播，top移出到一半的时候，重新开始
                    leftWrap.style.top = 0 + "px";
                }
                leftWrap.style.top = leftWrap.offsetTop - speedup + "px";
            }, 40);
        },
        autoPlayLeft1() { //向上轮播 
            var speedup = 1; //初始化速度
            var leftWrap = this.$refs.leftWrap && this.$refs.leftWrap[1]; //获取第二个leftWrap元素
            if (!leftWrap) return; //如果元素不存在，直接返回
            leftWrap.innerHTML += leftWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            leftWrap.style.height = oImgs.length * 200 + "px"; //680 是一张图片高度

            this.timerLeft1 = setInterval(function () {
                if (leftWrap.offsetTop < -400) { //向上轮播，top移出到一半的时候，重新开始
                    leftWrap.style.top = 0 + "px";
                }
                leftWrap.style.top = leftWrap.offsetTop - speedup + "px";
            }, 40);
        },
        autoPlayRight() { //向下轮播
            var speeddowm = 1; //初始化速度
            var rightWrap = this.$refs.rightWrap && this.$refs.rightWrap[0];
            if (!rightWrap) return; //如果元素不存在，直接返回
            rightWrap.innerHTML += rightWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            console.log(oImgs)
            rightWrap.style.height = oImgs.length * 200 + "px";

            this.timerRight = setInterval(function () {
                if (rightWrap.offsetTop >= 0) { //向下轮播，top移动到0的时候从一半的位置继续移动
                    rightWrap.style.top = -400 + "px";
                }
                rightWrap.style.top = rightWrap.offsetTop + speeddowm + "px";
            }, 40);
        },
        autoPlayRight1() { //向下轮播
            var speeddowm = 1; //初始化速度
            var rightWrap = this.$refs.rightWrap && this.$refs.rightWrap[1]; //获取第二个rightWrap元素
            if (!rightWrap) return; //如果元素不存在，直接返回
            rightWrap.innerHTML += rightWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            console.log(oImgs)
            rightWrap.style.height = oImgs.length * 200 + "px";

            this.timerRight1 = setInterval(function () {
                if (rightWrap.offsetTop >= 0) { //向下轮播，top移动到0的时候从一半的位置继续移动
                    rightWrap.style.top = -400 + "px";
                }
                rightWrap.style.top = rightWrap.offsetTop + speeddowm + "px";
            }, 40);
        },
        pasue(direction) {
            if (direction == "left") {
                clearInterval(this.timerLeft);
                clearInterval(this.timerLeft1);
            } else if (direction == "right") {
                clearInterval(this.timerRight);
                clearInterval(this.timerRight1);
            }
        },
        play(direction) {
            if (direction == "left") {
                this.autoPlayLeft();
                this.autoPlayLeft1();
            } else if (direction == "right") {
                this.autoPlayRight();
                this.autoPlayRight1();
            }
        },
        setFavoritos(item) {

            Fetch("/game/collect", {
                game_id: item.id,
                type: 1
            }).then(res => {
                if (res.code == 1) {
                    if (item.is_collect == 1) {
                        item.is_collect = 0;
                    } else {
                        item.is_collect = 1;
                    }
                    console.log(item)
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
@import "../assets/css/variables.less";

/* 添加分页过渡动画 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    transition: all 0.5s ease;
    position: absolute;
    width: 100%;
}

.slide-left-enter {
    transform: translateX(100%);
    opacity: 0;
}

.slide-left-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave {
    transform: translateX(0);
    opacity: 1;
}

.slide-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-right-enter {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-right-enter-to {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave {
    transform: translateX(0);
    opacity: 1;
}

.slide-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
}

/* 分页容器样式 */
.carousel-viewport {
    position: relative;
    width: 100%;
    min-height: 350px;
    /* 固定高度防止内容跳动 */
    overflow: hidden;
}

.carousel-wrapper {
    width: 100%;
    height: 100%;
}

.carousel-list {
    display: grid;
    gap: 0.2rem;
    grid-template-columns: repeat(4, 1fr);
    width: 95%;
    // height: 100%;
    margin: 0.2rem auto 0rem auto;
}

/* 游戏项样式 */
.game-item {
    width: 100%;
    margin-bottom: 0.3rem;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);

        .innerbox {
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
        }
    }
}

.new-list {
    position: relative;
    margin-bottom: 0.3rem;
}

.game_title {
    color: #fff;
    font-size: 0.4rem;
    margin: 0.4rem auto 6px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    box-sizing: border-box;

    .game_title_left {
        display: flex;
        align-items: center;
    }

    .game_title_right {
        display: flex;
        align-items: center;

        div {
            padding: .1rem .2rem;
            background-color: #ffffff14;
            border-radius: .2rem;
            margin-left: .1rem;
            font-size: .35rem;
        }
    }

    .more {
        font-size: 12px;
        color: @textcolor3;
    }

    img {
        width: 0.7rem;
        margin-right: 4px;
    }
}

.game-list {
    width: 95%;
    margin: 0.2rem auto 0rem auto;
    display: grid;
    gap: 0.2rem;
    grid-template-columns: repeat(4, 1fr);
}

.new-list .directionGanme-list {
    width: 100%;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
    overflow-y: hidden;
    /* 隐藏纵向滚动条 */
    scrollbar-width: none;
    /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none;
    /* IE/Edge 隐藏滚动条 */

    .game-item {
        // width: ;
        width: 3rem;
        display: inline-block;
    }
}

.directionGanme-list::-webkit-scrollbar {
    display: none;
}

.game-item {
    width: 100%;
    margin-bottom: 0.3rem;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
}

.innerbox {
    width: 100%;
    height: 4rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, .2);
    border-radius: .18rem;
    box-sizing: border-box;

    .like_icon {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 1;
    }

    // .bgImg {
    //   width: 2.8rem;
    //   height: 3.7rem;
    // }
    .good {
        width: 0.6rem;
    }
}

.slots-video {
    width: 95%;
    margin: 0 auto;
    margin-top: .4rem;
    position: relative;

    .video-info {
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        color: #fff;
        padding: 0 0 .5rem .875rem;
        font-size: .5rem;
        font-weight: 700;
    }

    img {
        border-radius: .3rem;
    }
}



.nowork {
    width: 100%;
    position: relative;
    z-index: 1;
    background: rgba(0, 0, 0, 0.34);
    margin: 0 auto;
    border-radius: 0.25rem;
}

.game_item_pg_name {
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 10px;
    font-weight: 500;
    height: 0.7rem;
    // line-height: 0.5rem;
}

.show_more {
    color: @anttextcolor;
    width: 95%;
    margin: 0 auto;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 11px;

    div {
        height: 0.5rem;
        line-height: 0.5rem;
        color: @textcolor3;
    }
}


.new-list {
    .game-list.case_5game-list {
        display: grid;
        gap: 0.2rem;
        grid-template-columns: repeat(4, 1fr);

        .game-item {
            width: 100%;
            height: 100%;

            .innerbox {
                width: 100%;
                height: 4rem;
            }
        }
    }
}

.slots_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @textcolor1;
    font-size: 0.5rem;
    text-align: center;
    height: 1rem;
    // padding-top: .5rem;
    // border-top: 0.01rem solid @anttextcolor;
    // margin-top: .3rem;
}

.slots_title::before {
    background-image: linear-gradient(90deg, rgba(0, 0, 0, .01) 0, @textcolor1);
    margin-right: .225rem;
    content: "";
    width: 2.5rem;
    height: 0.05rem;
}

.slots_title::after {
    background-image: linear-gradient(90deg, @textcolor1 0, rgba(0, 0, 0, .01));
    margin-left: .225rem;
    content: "";
    width: 2.5rem;
    height: 0.05rem;
}

.directionGanme-list .innerbox {
    width: 2.5rem;
}

.fake {
    width: 100%;
    height: 400px;

    .container {
        position: relative;
        display: flex;
        justify-content: center;
        padding-right: 10px;

        .left {
            display: inline-block;
            // width: 49%;
            height: 400px;
            // padding-left: 10px;
            margin-left: .2rem;
            box-sizing: border-box;

            img {
                width: 100%;
                margin-bottom: 10px;
                border-radius: .2rem;
            }
        }

        .right {
            display: inline-block;
            // width: 49%;
            // padding-left: 10px;
            margin-left: .2rem;

            box-sizing: border-box;

            img {
                width: 100%;
                margin-bottom: 10px;
                border-radius: .2rem;
            }
        }
    }

    #right {
        width: 23%;
        height: 400px;
        position: relative;
        overflow: hidden;

        #rightWrap {
            position: absolute;
            top: -400px;
            overflow: hidden;

            #rightWrap div {
                float: left;
                width: 100%;
                // height: 150px;

                img {
                    width: 100%;

                }
            }
        }
    }

    #left {
        width: 23%;
        height: 400px;
        position: relative;
        overflow: hidden;

        #leftWrap {
            position: absolute;
            // overflow-y: auto;

            #leftWrap div {
                float: left;
                width: 100%;
                // height: 150px;

                img {
                    width: 100%;

                }
            }
        }
    }
}

.case_5 {
    img#Promoção {
        width: 0.5rem;
        height: 0.5rem;
    }

    img#PG {
        width: 1.5rem;
    }

    img#PP {
        width: 2rem;
    }

    img#TADA {
        width: 1.5rem;

    }

    img#JDB {
        width: 1rem;
        height: 0.5rem;
    }

    img#CP {
        width: 1.5rem;
    }

    img#JILI {
        width: 1.5rem;
    }
}

@media (max-width: 480px) {
    .innerbox {
        height: 3rem !important;
    }
}

.link_user {
    box-sizing: border-box;
    background-color: #ff0000;
    width: 0.9rem;
    color: #fff;
    padding-top: .1rem;
    padding-bottom: .1rem;
    font-size: .24rem;
    text-align: center;
    // border-radius: .2rem;
    border-bottom-right-radius: .2rem;
}

/* 移动端游戏点击区域样式 */
.item-img {
    touch-action: manipulation; /* 优化移动端触摸体验 */
    -webkit-tap-highlight-color: transparent; /* 移除iOS默认点击高亮 */
}

.game-image {
    width: 100%;
    border-radius: .2rem;
    display: block;
    margin-bottom: 10px;
    touch-action: manipulation; /* 防止图片缩放等默认行为 */
    -webkit-tap-highlight-color: rgba(0,0,0,0.1); /* iOS 点击高亮 */
}

.game-image:active {
    opacity: 0.7; /* 移动端点击反馈 */
    transform: scale(0.98); /* 轻微缩放反馈 */
}

/* 移动端轮播容器优化 */
.fake .container {
    touch-action: pan-y; /* 允许垂直滚动，但限制其他触摸行为 */
}
</style>